export default __webpack_public_path__ + "static/media/bembossed.cc3939cb.jpg";